import { render } from "./ContactEnd.vue?vue&type=template&id=ae79e314"
import script from "./ContactEnd.vue?vue&type=script&lang=js"
export * from "./ContactEnd.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__